// purposely small JS file to include in the <head> of every page
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
